import { graphqlApi } from 'src/redux/api/graphql/graphqlApi'
import type { ReduxSuppliers } from 'src/types/apiType'

export const suppliersApi = graphqlApi.injectEndpoints({
	endpoints: (builder) => ({
		// Fetches supplier by Id
		fetchSupplierById: builder.query({
			query: (id: string) => ({
				queryName: 'getSuppliers',
				data: {
					id,
				},
				isList: false,
			}),
			transformResponse: (response: ReduxSuppliers) => response,
			providesTags: (result, error, id) => [{ type: 'Suppliers', id }],
		}),
		fetchSuppliersByTenantId: builder.query({
			query: ({
				tenantId,
				filter,
			}: {
				tenantId: string
				filter: any
			}) => ({
				queryName: 'suppliersByTenantId',
				data: {
					tenantId,
					filter,
					limit: 1000,
				},
				isList: true,
			}),
			transformResponse: (response: ReduxSuppliers[]) => response,
			providesTags: (result) =>
				result
					? [
							...result.map(({ id }) => ({
								type: 'Suppliers' as const,
								id: id as string,
							})),
							{ type: 'Suppliers', id: 'LIST' },
						]
					: [{ type: 'Suppliers', id: 'LIST' }],
		}),
	}),

	overrideExisting: false,
})

export const { useFetchSuppliersByTenantIdQuery, useFetchSupplierByIdQuery } =
	suppliersApi
